import React from 'react'
import CheckoutPage from '../../components/CheckoutPageComp/CheckoutPage'

const CheckOutPage = () => {
  return (
    <div>
        <CheckoutPage />

    </div>
  )
}

export default CheckOutPage